import { CareComponent } from './../care.component';
import { FormConfigurationModel } from './../../../../lib/ng2-sapmp/src/ui-components/form-builder/form-configuration.model';
import { Component, ApplicationRef, Directive, Input, OnChanges, OnInit, OnDestroy, AfterViewInit, AfterViewChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, AuthenticationService } from 'lib/ng2-sapmp/src/providers';
import { CareComponentService } from '../shared';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { MDMDetails } from './../../../models/product';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BREADCRUMBS, PREMIER_AUTHFAILURE_REDIRECT } from 'config';
import { PageLoaderService } from '../../../../lib/ng2-sapmp/src/ui-components/page-loader';
import { throwError } from 'rxjs';
import { CareModel } from '../shared';

import { ENV, ADDP_PERMISSION_MAPPING } from 'config';

@Component({
  selector: 'app-dashboard-title',
  templateUrl: './dashboard-title.component.html',
  styleUrls: ['./dashboard-title.component.scss'],
  providers: [CareComponentService],
})
export class DashboardTitleComponent implements OnInit, OnDestroy {
  private showSingleFan: boolean;
  public showErrors: boolean;
  public pageJson: any;
  public showData: boolean;
  public dashBoardForm: any;
  public source: string;
  public user: any;
  errorMessage: string;
  public clientIPAddress: string;
  private customerFan: any;
  private customerName: any;
  private customerEmail: any;
  private customerLaunchmode: String;
  private agentSingleFan: any;
  private agentProfileData: any;
  private showResetOption: boolean;
  mdmDetails: MDMDetails;

  constructor(private parentRouter: Router,
    private breadCrumbService: BreadCrumbService,
    private formBuilder: FormBuilder,
    private pageloaderService: PageLoaderService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute, private utilityService: UtilityService, private careService: CareComponentService) {
    this.showErrors = false;
    this.careService = careService;
    this.customerLaunchmode = 'singleFan';
    this.mdmDetails = new MDMDetails();
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()['/care/dashboard-title'];

    if (this.router.routerState.snapshot.url !== '/care/dashboardTitle') {
      this.breadCrumbService.setSource('/Customer data');
      this.breadCrumbService.setCurrentBreadCrumb({ label: 'Customer data', routerLink: 'care/dashboardTitle'});
    } else {
      this.breadCrumbService.setCurrentBreadCrumb({ label: 'Customer data', routerLink: 'care/dashboardTitle'});
    }

    this.dashBoardForm = new FormGroup({
      email: new FormControl('', [<any>Validators.required,
        <any>Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')]),
      fan: new FormControl('singleFan', [<any>Validators.required])
    });

    this.pageloaderService.setPageLoaderStatus(false);
    // this.careService.doRequestCareService(this.utilityService.getEnvConfig().getCarePageConfigUrl)
    //   .subscribe(respobj => {
        this.pageJson = this.route.snapshot.data.pageData.caredashboardTitle.caredashboardTitle;
        this.pageloaderService.setPageLoaderStatus(true);
        this.showData = true;
        this.agentProfileData = this.careService.getCareModel();
        if (!this.agentProfileData.searchFan) {
          const param = this.router.parseUrl(this.router.url).queryParams['fanInContext'];
          if (!param) {
            this.showResetOption = true;
            this.pageloaderService.setPageLoaderStatus(false);
            this.router.navigate(['searchFan'], { relativeTo: this.route.parent });
          } else {
            this.agentSingleFan = param;
            this.showResetOption = true;
            this.showSingleFan = true;
            this.createPageValidation();
          }
        } else {
          if (this.agentProfileData.showResetOption === true) {
            this.dashBoardForm.controls['email'].setValue('');
            this.agentProfileData.selectedLaunchMode = '';
          } else if (this.agentProfileData.selectedLaunchMode !== '') {
            this.dashBoardForm.controls['email'].setValue(this.agentProfileData.customerEmail);
            this.customerLaunchmode = this.agentProfileData.selectedLaunchMode;
            this.dashBoardForm.controls['fan'].validator = Validators.nullValidator;
          }
          this.agentSingleFan = this.agentProfileData.searchFan;
          this.showResetOption = true;
          this.showSingleFan = true;
          this.createPageValidation();
        }
      // }, error => {
      //   this.handleError(error);
      // });
  }

  handleError(error) {
    this.showErrors = true;
    return throwError(error);
  }

  next() {
    const email = this.dashBoardForm.value.email;
    let flag = '';
    let url = '';

    this.agentProfileData.searchFan = this.agentSingleFan;
    this.agentProfileData.customerEmail = email;
    this.agentProfileData.selectedLaunchMode = this.customerLaunchmode;
    this.agentProfileData.showResetOption = this.showResetOption;

    console.log(this.agentProfileData);

    if (!this.utilityService.getEnvConfig().useMock) {
      url = this.utilityService.getEnvConfig().careUpdateEmail;
    }else {
      url = this.utilityService.getEnvConfig().careUpdateEmailMock;
    }

    if (this.customerLaunchmode === 'singleFan') {
      this.careService.UpdateEmail(url, this.agentProfileData)
        .subscribe(respobj => {
          if (respobj.errorDescription) {
            this.errorMessage = respobj.errorDescription;
            this.showErrors = true;
            this.pageloaderService.setPageLoaderStatus(true);
          }else {
            sessionStorage.setItem('sapmp_jwtToken', respobj.jwtToken);
            this.careService.setCareModel(this.agentProfileData);
            this.authenticationService.careUserProfile()
              .subscribe(respobj1 => {
                this.source = 'care';
                this.user = this.authenticationService.getProfileModel(respobj1.profile);
                this.user.clientIPAddress = this.clientIPAddress;
                if (this.user.addpAuthority !== 'NONE') {
                  this.authenticationService.getFanSignedUpStatus()
                    .subscribe(resp => {
                      sessionStorage.setItem('initialSignupStatus', resp.initialSignupStatus);
                      sessionStorage.setItem('noOfDevice', resp.noOfDevices);
                      if(!resp.efotaFansSummary) {
                        sessionStorage.setItem('efotaEnrolledFanList', '[]');
                      }
                      else {
                        let efotaFansSum = resp.efotaFansSummary;
                        let efotaEnrolledFanList = [];
                        for(let i = 0 ; i < efotaFansSum.length ; i++) {
                          if(efotaFansSum[i].status == "ACTIVE") {
                           for(let j = 0 ; j < efotaFansSum[i].count ; j++) {
                             efotaEnrolledFanList.push(efotaFansSum[i].fans[j]);
                           }
                          }
                       }
                        sessionStorage.setItem('efotaEnrolledFanList', JSON.stringify(efotaEnrolledFanList));
                      }
                      if(!resp.efotaNotEnrolledFanList) {
                        sessionStorage.setItem('efotaNotEnrolledFanList', '[]');
                        sessionStorage.setItem('efotaEnrollmentInfo','[]');
                      }
                      else {
                        sessionStorage.setItem('efotaEnrollmentInfo',JSON.stringify(resp.efotaEnrollmentInfo));
                        sessionStorage.setItem('efotaNotEnrolledFanList', JSON.stringify(resp.efotaNotEnrolledFanList));
                      }

                      if (resp.allFansInEligible === true) {
                        this.user.fanSignedUpStatus = 'NotEligible';
                        // if(resp.noOfFans == 0 && resp.noOfDevices == 0 ){
                        //   this.user.fanSignedUpStatus = 'Unknown';
                        // }
                    } else {
                      if(resp.fansSummary.length > 0) {
                        let signupFanSum = resp.fansSummary;
                        let signupFanList = [];
                        let processingFanList = [];
                        for(let i=0; i< signupFanSum.length; i++) {
                          if(signupFanSum[i].status == "AWAITING_SIGNUP") {
                            for(let j = 0 ; j < signupFanSum[i].count ; j++) {
                              signupFanList.push(signupFanSum[i].fans[j]);
                            }
                          }
                        }
                        sessionStorage.setItem('signupFanList', JSON.stringify(signupFanList));
                        //for 'processing' fans
                        for(let i=0; i< signupFanSum.length; i++) {
                          if(signupFanSum[i].status == "PROCESSING") {
                            for(let j = 0 ; j < signupFanSum[i].count ; j++) {
                              //processingFanList.push(signupFanSum[i].fans[j]);
                              //getting fan info of 'processing' fan to store in session storage
                              for(let k=0; k < resp.fanInfoList.length; k++) {
                                if (signupFanSum[i].fans[j] === resp.fanInfoList[k].fan) {
                                  processingFanList.push(resp.fanInfoList[k]);
                                }
                              }
                            }
                          }
                        }
                        sessionStorage.setItem('processingFanList', JSON.stringify(processingFanList));
                      }
                      if (this.user) {
                        this.user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
                     }
                     if (resp.productCode !== null && resp.productCode !== undefined) {
                      this.mdmDetails.productCode = resp.productCode;
                      this.mdmDetails.latestAccountType = resp.recentlyEnrolledProduct;
                      if (this.mdmDetails.productCode === 'ADDPMDM') {
                        this.mdmDetails.ibmEmmAccountId = resp.ibmEmmAccountId;
                        let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
                        productDetails.emmProductCode = 'ADDPMDM';
                        productDetails.selectedAccID = resp.ibmEmmAccountId;
                        productDetails.signupEmmStatus = 'revised';
                        sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
                      }else {
                          if (resp.googleEmmAccountId !== null && resp.googleEmmAccountId !== undefined) {
                            this.mdmDetails.googleEmmAccountId = resp.googleEmmAccountId;
                           }
                          if (resp.samsungEmmAccountId !== null && resp.samsungEmmAccountId !== undefined) {
                            this.mdmDetails.samsungEmmAccountId = resp.samsungEmmAccountId;
                           }
                          if (resp.fanInfoList !== null && resp.fanInfoList !== undefined) {
                            sessionStorage.setItem('fanInfoList', JSON.stringify(resp.fanInfoList));
                           }
                      }
                      sessionStorage.setItem('mdmDetails', JSON.stringify(this.mdmDetails));
                    }
                   }
                    this.authenticationService.setUser(this.user);
                        sessionStorage.setItem('permissions', JSON.stringify(respobj1.permissions));
                        const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
                        const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
                        if (redirectInfo) {
                              this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
                        }
                        // this.loginSuccessRedirect();
                        this.router.navigate(['dashboard']);
                    }, error => {
                      this.user.fanSignedUpStatus = 'Error';
                      this.authenticationService.setUser(this.user);
                      sessionStorage.setItem('permissions', JSON.stringify(respobj1.permissions));
                      const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
                      const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
                      if (redirectInfo) {
                            this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
                      }
                      this.router.navigate(['dashboard']);
                    });
                } else {
                  this.authenticationService.setUser(this.user);
                  const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
                        const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
                        if (redirectInfo) {
                              this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
                        }
                  sessionStorage.setItem('permissions', JSON.stringify(respobj1.permissions));
                  // this.loginSuccessRedirect();
                  this.router.navigate(['dashboard']);
                }
                // this.router.navigate(['dashboard']);
              }, error => {
                this.errorMessage = 'Something went wrong. Please try again later.';
                this.handleError(error);
              });
          }
        }, error => {
          this.handleError(error);
        });
    }else {
      if (this.agentProfileData.tcmAopEmailAddress == null || this.agentProfileData.tcmAopEmailAddress === '') {
            this.errorMessage = 'This account does not have an authorized user for the device management program.';
        this.showErrors = true;
      } else if (email !== (this.agentProfileData.tcmAopEmailAddress.filter(emailAddress => {
        if (emailAddress === this.dashBoardForm.value.email) {
          flag = emailAddress;
          return flag;
        }
      }) ? flag : '')) {
        this.errorMessage = 'You have entered the wrong email address or the provided email ' +
        'is not authorized for the entered foundation account. Please enter a different email.';
        this.showErrors = true;
      } else {
        this.careService.UpdateEmail(url, this.agentProfileData)
          .subscribe(respobj => {
            if (respobj.errorDescription) {
              this.errorMessage = respobj.errorDescription;
              this.showErrors = true;
              this.pageloaderService.setPageLoaderStatus(true);
            }else {
              sessionStorage.setItem('sapmp_jwtToken', respobj.jwtToken);
              this.agentProfileData.customerEmail = email;
              this.careService.setCareModel(this.agentProfileData);
              this.router.navigate(['selectFanTable'], { relativeTo: this.route.parent });
            }
          }, error => {
            this.handleError(error);
          });
      }
    }
    // }
  }

  AfterViewInit() {
    this.showSingleFan = false;
  }

  setOptionValue(option) {
    this.customerLaunchmode = option;
    // if(option=="singleFan"){
    //   this.dashBoardForm.controls['email'].validator = Validators.nullValidator;

    // }
    // else{
    //   this.dashBoardForm.controls['email'].validator = Validators.compose([
    //      Validators.required,Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')]);
    // }
    // this.dashBoardForm.controls['email'].updateValueAndValidity();

  }

  editMessage() {
    if (this.showResetOption) {
      this.router.navigate(['searchFan'], { relativeTo: this.route.parent });
    }
  }
  createPageValidation() {
    this.dashBoardForm = this.formBuilder.group({
      // 'name': this.name,
      'email': this.dashBoardForm.controls['email'],
      'fan': this.dashBoardForm.controls['fan']
    });
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
    // Alert initialization on login
    const event = document.createEvent('Event');
    event.initEvent('userLogged', true, true);
    document.dispatchEvent(event);
  }

  getFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = 'NONE';
    if (fansSummary) {
      const signedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'ACTIVE' || f.status === 'READY_TO_SETUP'; }).length;
      const notSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'PROCESSING' || f.status === 'AWAITING_SIGNUP'; }).length;
      if (signedUpFansCount > 0 && notSignedUpFansCount > 0) {
        fanSignedUpStatus = 'SOME';
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = 'ALL';
      } else {
        fanSignedUpStatus = 'NONE';
      }
    }
    return fanSignedUpStatus;
  }

}
